import { render } from "./ModalComponent.vue?vue&type=template&id=dccdfecc&scoped=true&ts=true"
import script from "./ModalComponent.ts?vue&type=script&lang=ts"
export * from "./ModalComponent.ts?vue&type=script&lang=ts"

import "./ModalComponent.scss?vue&type=style&index=0&id=dccdfecc&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dccdfecc"]])

export default __exports__